import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Meta } from '@nextiva/next-ui';

import ErrorBoundary from 'components/ErrorBoundary';
import routerParams from 'config/routerParams';
import TakerAppHashRouteRedirect from '../components/TakerAppHashRouteRedirect';
import TakerApp from '../containers/TakerApp';

const Routes = ({ store }) => (
  <ErrorBoundary>
    <Meta title="Surveys — NextOS" template="Surveys — NextOS" />
    <Provider store={store}>
      <Router basename={process.env.TAKER_PUBLIC_PATH}>
        <Switch>
          <Route path={`/:${routerParams.surveyUuid}`} component={TakerApp} />
          <Route render={TakerAppHashRouteRedirect} />
        </Switch>
      </Router>
    </Provider>
  </ErrorBoundary>
);

Routes.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Routes;
